var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19532 3.52869C8.32034 3.40371 8.48988 3.3335 8.66666 3.3335C8.84343 3.3335 9.01297 3.40371 9.13799 3.52869L13.138 7.52869C13.263 7.65371 13.3332 7.82324 13.3332 8.00002C13.3332 8.1768 13.263 8.34634 13.138 8.47135L9.13799 12.4714C9.01225 12.5928 8.84385 12.66 8.66906 12.6585C8.49426 12.657 8.32705 12.5868 8.20344 12.4632C8.07984 12.3396 8.00973 12.1724 8.00821 11.9976C8.00669 11.8228 8.07388 11.6544 8.19532 11.5287L11.0573 8.66669H3.33332C3.15651 8.66669 2.98694 8.59645 2.86192 8.47142C2.73689 8.3464 2.66666 8.17683 2.66666 8.00002C2.66666 7.82321 2.73689 7.65364 2.86192 7.52862C2.98694 7.40359 3.15651 7.33335 3.33332 7.33335H11.0573L8.19532 4.47135C8.07034 4.34634 8.00013 4.1768 8.00013 4.00002C8.00013 3.82324 8.07034 3.65371 8.19532 3.52869V3.52869Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeArrow);
export default __webpack_public_path__ + "static/media/ChangeArrow.5b2f72ad.svg";
export { ForwardRef as ReactComponent };